import { Paper, Typography } from '@mui/material'

export default function Card({ title, value, onClick }) {
  return (
    <Paper onClick={onClick} sx={{ p: 2, cursor: onClick ? 'pointer' : 'default' }}>
      <Typography variant="caption" color="text.secondary">{title}</Typography>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        {Number(value || 0).toLocaleString('sk-SK', { style: 'currency', currency: 'EUR' })}
      </Typography>
      {onClick && <Typography variant="body2" color="text.secondary">klik pre detail</Typography>}
    </Paper>
  )
}
